export const MEGA_TIER_HASHTAGS = ['DeepValue', 'ValueInvesting', 'Piotroski', 'BenjaminGraham'];

export const megaTierShareText = (r) => {
  const stage = r.stage3_pass ? 'Mega Tier ELITE' : r.stage2_pass ? 'Mega Tier Stage 2' : 'Mega Tier Stage 1';
  const roc = typeof r.roc === 'number' ? `${(r.roc * 100).toFixed(0)}% return on capital` : null;
  const ey = typeof r.earnings_yield === 'number' ? `${(r.earnings_yield * 100).toFixed(1)}% earnings yield` : null;
  const netNet = r.net_net ? ', trades under ⅔ of net current assets (net-net)' : '';
  return `$${r.ticker} — ${stage}: ${[roc, ey].filter(Boolean).join(', ')}, Graham ${r.graham_score}/5, Piotroski F-Score ${r.f_score}/9${netNet}. Deep value without the traps:`;
};
